import {GuideStateApi} from "@repo/guide-state";
import {
    isValidContentLocation,
    makeLinksFromGQLObjects,
    type ValidContentLocation,
} from "@repo/guide-utils";

import type {AITeacherTools_ArticleDetails_articleById as Article} from "./__graphql-types__/AITeacherTools_ArticleDetails.ts";
import type {
    AITeacherTools_ExerciseDetails_exerciseById as Exercise,
    AITeacherTools_ExerciseDetails_exerciseById_parentTopic_allLearnableContent as ExerciseRelatedContent,
} from "./__graphql-types__/AITeacherTools_ExerciseDetails.ts";
import type {AITeacherTools_VideoDetails_videoById as Video} from "./__graphql-types__/AITeacherTools_VideoDetails.ts";

type LearnableContent_PromptVariables = {
    __typename:
        | Article["__typename"]
        | Exercise["__typename"]
        | Video["__typename"];
    defaultUrlPath: string | null | undefined;
    id: string;
    parentTopic:
        | Article["parentTopic"]
        | Exercise["parentTopic"]
        | Video["parentTopic"];
};

export function setSharedDetails(
    learnableContent: LearnableContent_PromptVariables,
) {
    GuideStateApi.set(
        "contextualLinks",
        collectRelatedContentLinks(
            learnableContent.parentTopic?.allLearnableContent,
        ),
    );
    GuideStateApi.set("contentURLPath", learnableContent.defaultUrlPath);
}

export function unsetSharedDetails() {
    GuideStateApi.set("contentURLPath", null);
    GuideStateApi.set("contextualLinks", []);
}

const collectRelatedContentLinks: (
    relatedContent: Nullable<Nullable<ExerciseRelatedContent>[]>,
) => string[] = (
    relatedContent: Nullable<Nullable<ExerciseRelatedContent>[]>,
) => {
    if (!relatedContent || relatedContent === null) {
        return [];
    }
    const nonNullObjects: ValidContentLocation[] = relatedContent.reduce(
        (acc, node) => {
            if (isValidContentLocation(node)) {
                acc.push(node);
            }
            return acc;
        },
        [] as ValidContentLocation[],
    );
    return makeLinksFromGQLObjects(nonNullObjects);
};
